module.exports = __webpack_public_path__ + "img/web2icon2.53b20d69.png";